var _path, _rect, _rect2;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCreateDoc(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 13.3a.3.3 0 00-.3-.3H4a1 1 0 01-1-1V3a1 1 0 011-1h4.558a1 1 0 01.781.375l2.442 3.053a1 1 0 01.219.624V7.7a.3.3 0 00.3.3h1.4a.3.3 0 00.3-.3V6.052a3 3 0 00-.657-1.874L10.9 1.126A3 3 0 008.558 0H4a3 3 0 00-3 3v9a3 3 0 003 3h3.7a.3.3 0 00.3-.3v-1.4z",
    fill: "currentColor"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 10,
    width: 2,
    height: 6,
    rx: 0.4,
    fill: "currentColor"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 14,
    width: 2,
    height: 6,
    rx: 0.4,
    transform: "rotate(-90 10 14)",
    fill: "currentColor"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoIGQ9Ik04IDEzLjNDOCAxMy4xMzQzIDcuODY1NjkgMTMgNy43IDEzSDRDMy40NDc3MiAxMyAzIDEyLjU1MjMgMyAxMlYzQzMgMi40NDc3MiAzLjQ0NzcyIDIgNCAySDguNTU4MTNDOC44NjE5MSAyIDkuMTQ5MjIgMi4xMzgwOSA5LjMzODk5IDIuMzc1M0wxMS43ODA5IDUuNDI3NjVDMTEuOTIyNyA1LjYwNDk2IDEyIDUuODI1MjcgMTIgNi4wNTIzNFY3LjdDMTIgNy44NjU2OSAxMi4xMzQzIDggMTIuMyA4SDEzLjdDMTMuODY1NyA4IDE0IDcuODY1NjkgMTQgNy43VjYuMDUyMzRDMTQgNS4zNzExMyAxMy43NjgyIDQuNzEwMiAxMy4zNDI2IDQuMTc4MjZMMTAuOTAwNyAxLjEyNTkxQzEwLjMzMTQgMC40MTQyNjkgOS40Njk0OCAwIDguNTU4MTMgMEg0QzIuMzQzMTUgMCAxIDEuMzQzMTUgMSAzVjEyQzEgMTMuNjU2OSAyLjM0MzE1IDE1IDQgMTVINy43QzcuODY1NjkgMTUgOCAxNC44NjU3IDggMTQuN1YxMy4zWiIgZmlsbD0iY3VycmVudENvbG9yIi8+CiAgICA8cmVjdCB4PSIxMiIgeT0iMTAiIHdpZHRoPSIyIiBoZWlnaHQ9IjYiIHJ4PSIwLjQiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgogICAgPHJlY3QgeD0iMTAiIHk9IjE0IiB3aWR0aD0iMiIgaGVpZ2h0PSI2IiByeD0iMC40IiB0cmFuc2Zvcm09InJvdGF0ZSgtOTAgMTAgMTQpIiBmaWxsPSJjdXJyZW50Q29sb3IiLz4KPC9zdmc+Cg==";
export { SvgCreateDoc as ReactComponent };